import { ViewEncapsulation } from '@angular/core';
import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { Baners } from 'src/app/api/WickedApiClient';
import { bannerZoneServices } from 'src/app/Services/bannerZoneServices.service';
import { MainService } from 'src/app/Services/service.service';

@Component({
  selector: 'app-banner-zone-map',
  templateUrl: './banner-zone-map.component.html',
  styleUrls: ['./banner-zone-map.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BannerZoneMapComponent implements OnInit {

  public zoneParams:BannerParams;

  constructor(public bannersService:bannerZoneServices, public service: MainService, ) {
    this.zoneParams = new BannerParams();
   }

  public targetIsHorizontal:boolean = false;
  private _zoneType:string | Array<string> = "";
  public targetImg:string;
  public targetUrl:string;
  public userBaners:Array<Baners> = [];
  private userBanerIndex: number = null;
  public rndUserBanerImg: string = null;
  public rndUserBanerUrl: string = null;
  private banerChance: number = 0; //1 = 100%, 0.5 = 50%
  sub: Subscription;

  @Input() public isMobile: boolean = false; 

  @Input("zoneType")
  public set zoneType(value: string | Array<string>)
  {
      this._zoneType = value;
  }

  public get zoneType():string | Array<string>
  {
    
    if(Array.isArray(this._zoneType)){
      this._zoneType = this._zoneType[Math.floor(Math.random()*this._zoneType.length)];
    }
    
    return this._zoneType;
    
  }

  public mapParams(zone:string)
  {
    // switch(zone)
    // {
    //   case "Main-Home-Standard-Top":
    //     this.zoneParams.height = 728;
    //     this.zoneParams.width = 90;
    //     this.zoneParams.url = '//a.realsrv.com/iframe.php?idzone=3944080&size=728x90"';
    //   return;
    // }
  }


  ngOnInit() {
    if(Math.random() < this.banerChance){
      this.sub = this.bannersService.userBanersIsReady$.subscribe(result => {
        this.userBaners = this.bannersService.userBaners;
        if(this.userBaners.length > 0){
          const randomBaner = Math.floor(Math.random() * this.userBaners.length);
          this.userBanerIndex = randomBaner;

          this.rndUserBanerUrl =this.userBaners[this.userBanerIndex].banerUrl;

          let banerPath = "";
          if(this.isMobile) banerPath = this.userBaners[this.userBanerIndex].mobileImage;
          else if(this.targetIsHorizontal){
            banerPath = this.userBaners[this.userBanerIndex].desktopImageHorizontal;
          }else{
            banerPath =  this.userBaners[this.userBanerIndex].desktopImageVertical;
          }
          this.bannersService.removeUsedBanerFromList(this.userBanerIndex)
          this.rndUserBanerImg = banerPath;
        }
      })
    }
    
  }
  

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if(this.userBanerIndex){
      this.bannersService.addUserBaner(this.userBaners[this.userBanerIndex]);
    }
  }

  getValidUrl = (url = "") => {
    if(url ==="#") return url;
    let newUrl = window.decodeURIComponent(url);
    newUrl = newUrl.trim().replace(/\s/g, "");

    if(/^(:\/\/)/.test(newUrl)){
        return `http${newUrl}`;
    }
    if(!/^(f|ht)tps?:\/\//i.test(newUrl)){
        return `http://${newUrl}`;
    }

    return newUrl;
};

}
declare global {
  interface Window {
    decodeURIComponent: any;
  }
}
export class BannerParams
{
  url:string;
  width:number;
  height:number

}
